<template>
  <div id="app">
    <BoxConfigurator/>
  </div>
</template>

<script>
import BoxConfigurator from './components/BoxConfigurator.vue'

export default {
  name: 'app',
  components: {
    BoxConfigurator
  }
}
</script>

<style>
html, body {
  background-color: #FFF;
  height: 100%;
  width: 100%;
}
</style>